app.directive("noresults",function(_$filter){
     
        
   return {
       restrction:"E",
       scope:{
           
            show:"="
       },
       templateUrl:"/assets/js/angular/components/directives/noresults/noresults.html"
       
   };     
        
        
});
